import type { AnnotationData } from '@/modules/Editor/AnnotationData'
import type { Action } from '@/modules/Editor/managers/actionManager'
import type { Annotation } from '@/modules/Editor/models/annotation/Annotation'
import { shallowCloneAnnotation } from '@/modules/Editor/models/annotation/cloneAnnotation'
import type { View } from '@/modules/Editor/views/view'

// Updates the annotation data inside an action.
export function updateAnnotationsData(
  view: View,
  annotations: Annotation[],
  oldData: AnnotationData[],
  newData: AnnotationData[],
): Action {
  const frameIndex = view.currentFrameIndex
  return {
    do(): boolean {
      annotations.forEach((annotation, index) => {
        annotation.centroid = undefined

        view.annotationManager.updateAnnotation(
          shallowCloneAnnotation(annotation, { data: newData[index] }),
          {
            updatedFramesIndices: [frameIndex],
          },
        )
      })
      return true
    },

    undo(): boolean {
      annotations.forEach((annotation, index) => {
        annotation.centroid = undefined
        view.annotationManager.updateAnnotation(
          shallowCloneAnnotation(annotation, { data: oldData[index] }),
          {
            updatedFramesIndices: [frameIndex],
          },
        )
      })
      return true
    },
  }
}
